import React from 'react';
import cl from "./InfoBlock.module.css";
import {Paper} from "@mui/material";

const InfoBlock = ({children}) => {

    return (
        <Paper variant="outlined" sx={{
            backgroundColor: "#e0e0e8",
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            gap: "15px"
        }}>
            <div className={cl.header}>
                <span className={cl.title}>{children}</span>
            </div>
        </Paper>
    );
};

export default InfoBlock;